/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rag_Context_And_Concierge_ManaInputs */

const en_rag_context_and_concierge_mana = /** @type {(inputs: Rag_Context_And_Concierge_ManaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG context and concierge management`)
};

const es_rag_context_and_concierge_mana = /** @type {(inputs: Rag_Context_And_Concierge_ManaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contexto RAG y gestión de conserjería`)
};

const fr_rag_context_and_concierge_mana = /** @type {(inputs: Rag_Context_And_Concierge_ManaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contexte RAG et gestion du concierge`)
};

const de_rag_context_and_concierge_mana = /** @type {(inputs: Rag_Context_And_Concierge_ManaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG-Kontext und Concierge-Management`)
};

const ja_rag_context_and_concierge_mana = /** @type {(inputs: Rag_Context_And_Concierge_ManaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAGコンテキストとコンシェルジュ管理`)
};

const zh_rag_context_and_concierge_mana = /** @type {(inputs: Rag_Context_And_Concierge_ManaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG 上下文与礼宾客服管理`)
};

const ar_rag_context_and_concierge_mana = /** @type {(inputs: Rag_Context_And_Concierge_ManaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سياق RAG وإدارة المساعد الذكي`)
};

const id_rag_context_and_concierge_mana = /** @type {(inputs: Rag_Context_And_Concierge_ManaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konteks RAG dan manajemen pramutamu`)
};

const it_rag_context_and_concierge_mana = /** @type {(inputs: Rag_Context_And_Concierge_ManaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contesto RAG e gestione del concierge`)
};

const ru_rag_context_and_concierge_mana = /** @type {(inputs: Rag_Context_And_Concierge_ManaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление контекстом RAG и ИИ-Консьержем`)
};

const pt_rag_context_and_concierge_mana = /** @type {(inputs: Rag_Context_And_Concierge_ManaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contexto RAG e gerenciamento de concierge`)
};

const ko_rag_context_and_concierge_mana = /** @type {(inputs: Rag_Context_And_Concierge_ManaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG 컨텍스트 및 컨시어지 관리`)
};

/**
* | output |
* | --- |
* | "RAG context and concierge management" |
*
* @param {Rag_Context_And_Concierge_ManaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rag_context_and_concierge_mana = /** @type {((inputs?: Rag_Context_And_Concierge_ManaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rag_Context_And_Concierge_ManaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rag_context_and_concierge_mana(inputs)
	if (locale === "es") return es_rag_context_and_concierge_mana(inputs)
	if (locale === "fr") return fr_rag_context_and_concierge_mana(inputs)
	if (locale === "de") return de_rag_context_and_concierge_mana(inputs)
	if (locale === "ja") return ja_rag_context_and_concierge_mana(inputs)
	if (locale === "zh") return zh_rag_context_and_concierge_mana(inputs)
	if (locale === "ar") return ar_rag_context_and_concierge_mana(inputs)
	if (locale === "id") return id_rag_context_and_concierge_mana(inputs)
	if (locale === "it") return it_rag_context_and_concierge_mana(inputs)
	if (locale === "ru") return ru_rag_context_and_concierge_mana(inputs)
	if (locale === "pt") return pt_rag_context_and_concierge_mana(inputs)
	return ko_rag_context_and_concierge_mana(inputs)
});